import script from "./informationCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./informationCollection.vue?vue&type=script&setup=true&lang=js"

import "./informationCollection.vue?vue&type=style&index=0&id=1ab5daa8&lang=scss&scope=true"

const __exports__ = script;

export default __exports__